import { render, staticRenderFns } from "./Diagnosis.vue?vue&type=template&id=40e22588"
import script from "./Diagnosis.vue?vue&type=script&lang=js"
export * from "./Diagnosis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports